export function LegalCapabilitiesSlide({ isActive: _ }: { isActive: boolean }) {
  const skills = [
    { title: "Document Ingestion", what: "Turn unstructured documents into submission-ready data. Any format, any source, organised and standardised automatically.", how: "\u201CUpload the client file for the Patel matter.\u201D" },
    { title: "Data Extraction", what: "Extracts key information across documents. Compares fields, detects conflicts, and highlights inconsistencies.", how: "Cross-references passport, bank statements, and employment letters." },
    { title: "Knowledge Base", what: "Draws on a private, per-firm knowledge base. Your precedents, your templates, your institutional knowledge.", how: "Every case follows your firm\u2019s best practice by default." },
    { title: "Form Preparation", what: "Prepares application forms using verified case data. UKVI, Land Registry, court forms, and any regulated format.", how: "\u201CPrepare the Tier 2 application for Chen.\u201D No manual data entry." },
    { title: "Compliance Checking", what: "Cross-checks details across forms and evidence. Flags gaps, inconsistencies, and missing documents.", how: "Runs verification checks and highlights anything that needs attention." },
    { title: "Secure Storage", what: "AES-256 encryption at rest and in transit. UK/EU data residency. Matter-level isolation.", how: "All documents encrypted and isolated per matter at all times." },
  ];

  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
        The skills behind the agent
      </h2>
      <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-4">
        Each skill is designed for regulated legal workflows, with encryption, audit trails, and professional review built into every step.
      </p>

      <div className="grid grid-cols-3 gap-3">
        {skills.map((s) => (
          <div key={s.title} className="flex flex-col border border-[var(--color-border)] px-4 py-3 rounded-sm">
            <h3 className="text-[13px] font-medium mb-1.5">{s.title}</h3>
            <p className="text-[10px] text-[var(--color-fg-secondary)] leading-relaxed mb-2">{s.what}</p>
            <p className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] leading-relaxed italic">{s.how}</p>
          </div>
        ))}
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          From document intake to submission, the entire workflow is structured, automated, and review-ready. Audit logging and professional review are built into every step.
        </p>
      </div>
    </div>
  );
}
